import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';

import { getAMLSCommonNotifications } from '../../../../redux/actions/common';
import NotificationsDropdown from './dropdown';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    moduleId: state.authentication?.currentProductLogin?.moduleId,
    notifications: get(
      state,
      'amlsCommon.commonNotifications.data.notifications',
      []
    ),
    unreadCount: get(
      state,
      'amlsCommon.commonNotifications.data.unreadCount',
      0
    ),
    notificationsApiStatus: get(
      state,
      'amlsCommon.commonNotifications.isLoading',
      false
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAMLSCommonNotifications: (params) => {
      dispatch(getAMLSCommonNotifications(params));
    }
  };
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NotificationsDropdown)
);
